import { emailSchema, nameSchema, phoneNumberSchema } from "utils/schemas";
import * as Yup from "yup";

const schema = Yup.object({
  ...nameSchema,
  phone: phoneNumberSchema,
  email: emailSchema,
  avatar: Yup.mixed().nullable().optional(),

  roleIds: Yup.array()
    .of(Yup.number().required())
    .required("The role field is required"),
  password: Yup.string().when("isEdit", {
    is: true,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) =>
      schema
        .required("The password field is required")
        .min(8, "Password must be at least 8 characters"),
  }),

  confirmPassword: Yup.string().when("isEdit", {
    is: true,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) =>
      schema
        .required("The confirm password field is required")
        .oneOf([Yup.ref("password")], "Passwords must match"),
  }),
});

export default schema;
